export function formatQtd(valor: number | string | null | undefined): string {
  if (valor === '' || valor == null) return '';
  const n = Number(String(valor).replace(',', '.'));
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
}

// Parse pt-BR ("1.600,5") ou en-US ("1600.5"). Heuristica:
//   tem virgula → decimal pt-BR; padrao "999.999" → milhares pt-BR; senao → en-US.
export function parseQtd(valor: string | number | null | undefined): number {
  if (valor === '' || valor == null) return NaN;
  if (typeof valor === 'number') return valor;
  const s = String(valor).trim();
  if (s === '') return NaN;
  if (s.includes(',')) return Number(s.replace(/\./g, '').replace(',', '.'));
  if (/^\d{1,3}(\.\d{3})+$/.test(s)) return Number(s.replace(/\./g, ''));
  return Number(s);
}
